import FinancePanel from './panel'
import FinanceInvoice from './invoice'
import FinancePayment from './payment'
import FinancePurchaseOrder from './purchaseOrder'

import {
  LAYOUT_VENDOR_FINANCE_PANEL,
  LAYOUT_VENDOR_FINANCE_PO_ROOT,
  LAYOUT_VENDOR_FINANCE_INVOICE_ROOT,
  LAYOUT_VENDOR_FINANCE_PAYMENT_ROOT
} from './navigation'

const routes = [
  {
    path: LAYOUT_VENDOR_FINANCE_PANEL,
    component: FinancePanel,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_FINANCE_INVOICE_ROOT,
    component: FinanceInvoice,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_FINANCE_PAYMENT_ROOT,
    component: FinancePayment,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_VENDOR_FINANCE_PO_ROOT,
    component: FinancePurchaseOrder,
    allowToOneOf: ['ROLE_TYPE_VENDOR']
  }
]

export default routes
